import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useHasLocationsToRender from '@rsos/hooks/useHasLocationsToRender';
import { useSelectedTextFrom911Conversation } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Selectors';
import { dismissTF911TransitionBanner } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Slice';
import DidCallBanner from './DidCallBanner';
import NoLocationBanner from './NoLocationBanner';

const TextFrom911BannersContainer = () => {
  const dispatch = useDispatch();

  const hasLocationsToRender = useHasLocationsToRender();

  const selectedCallerID = useSelector(
    state => state?.emergencyCalls?.selectedCallerID,
  );

  const conversation = useSelectedTextFrom911Conversation(selectedCallerID);

  const isOutboundSMSConversation = useMemo(
    () => conversation?.data?.isOutboundSMS,
    [conversation],
  );

  const isTF911TransitionBannerDismissed = useMemo(
    () => conversation?.ui?.isTF911TransitionBannerDismissed,
    [conversation],
  );

  const handleDismissBanner = useCallback(() => {
    dispatch(
      dismissTF911TransitionBanner({
        callerID: selectedCallerID,
      }),
    );
  }, [dispatch, selectedCallerID]);

  if (!isOutboundSMSConversation) {
    return null;
  }

  return (
    <>
      {!isTF911TransitionBannerDismissed ? (
        <>
          {hasLocationsToRender ? (
            <DidCallBanner onDismiss={handleDismissBanner} />
          ) : (
            <NoLocationBanner />
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default React.memo(TextFrom911BannersContainer);
